import axios from 'axios';

// A captcha that never loads blocks the form for a real visitor, but does so
// silently — the browser shows a disabled button and nothing reaches the server.
// Report it once per page load so lead loss is visible in monitoring instead of
// only in the visitor's console.
//
// The endpoint is same origin (the tenant domain serves the same application),
// path-literal for the same reason the frame src is: Ziggy is not guaranteed to
// be present on every page that embeds the widget.
const ENDPOINT = '/captcha/unavailable';

const reported = new Set();

export function reportCaptchaUnavailable(action, reason) {
    const key = `${action}:${reason}`;

    if (reported.has(key)) {
        return;
    }

    reported.add(key);

    // Fire and forget: this is diagnostics, it must never affect the form.
    axios.post(ENDPOINT, { action, reason }).catch(() => {});
}
